export default {
  // 云服务提供者
  cloudProvider: {
    locked: '已锁定',
    gcp: 'Google Cloud Platform',
    aws: 'Amazon Web Services',
    current: '当前云服务提供者',
    switch: '切换云服务提供者',
    select: '选择云服务提供者'
  },

  // 通用
  common: {
    loading: '加载中...',
    save: '保存',
    status: '状态',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    close: '关闭',
    confirm: '确认',
    search: '搜索',
    refresh: '刷新',
    create: '创建',
    start: '启动',
    stop: '停止',
    yes: '是',
    no: '否',
    ok: '确定',
    error: '错误',
    success: '成功',
    warning: '警告',
    info: '信息',
    copy: '复制',
    viewDetails: '查看详情',
    none: '无',
    copyFailed: '复制失败，请手动复制',
    sshCommandCopied: 'SSH 命令已复制到剪贴板',
    unknown: '未知'
  },

  // 导航和菜单
  navigation: {
    topology: '拓扑图视图',
    list: '列表视图',
    audit: '审计日志',
    gcpManager: 'GCP管理器',
    awsManager: 'AWS管理器',
    projectId: '项目ID',
    loadResources: '加载资源',
    loadPrompt: '点击下方按钮加载项目资源'
  },

  // 统计信息
  stats: {
    virtualMachines: '虚拟机',
    disks: '磁盘',
    createVM: '创建VM',
    createDisk: '创建磁盘'
  },

  // 用户信息
  user: {
    role: '角色',
    viewer: '查看者',
    editor: '编辑者',
    admin: '管理员'
  },

  // 过滤器
  filters: {
    searchPlaceholder: '搜索 VMs 或 Disks...',
    showRunningOnly: '仅显示运行中的 VM'
  },

  // VM相关
  vm: {
    name: '虚拟机名称',
    zone: '区域',
    machineType: '机器类型',
    cpu: 'CPU',
    memory: '内存',
    gpu: 'GPU',
    systemDisk: '系统盘',
    running: '运行中',
    stopped: '已停止',
    starting: '启动中',
    stopping: '停止中',
    shuttingDown: '关闭中',
    terminated: '已终止',
    provisioning: '配置中',
    staging: '准备中',
    repair: '修复中',
    pending: '等待中',
    unknown: '未知',
    startVM: '启动VM',
    stopVM: '停止VM',
    deleteVM: '删除VM',
    editLabels: '编辑标签',
    // VM换spec相关
    resizeVM: {
      title: '调整VM规格',
      currentSpecs: '当前规格',
      autoSelectedType: '自动选择的机器类型',
      resize: '调整规格',
      resizing: '调整中...',
      cancel: '取消',
      error: {
        resizeFailed: '调整规格失败'
      }
    },
    noVMs: '暂无虚拟机',
    internalIP: '内部IP',
    externalIP: '外部IP',
    sshCommand: 'SSH命令',
    hasExternalIP: '有外部IP，可直接连接',
    noExternalIP: '无外部IP，使用IAP隧道',
    ssmSessionManager: '使用AWS SSM Session Manager连接',
    sshCommandCopied: 'SSH命令已复制到剪贴板',
    details: '虚拟机详情',
    attachedDisks: '附加磁盘',
    na: 'N/A',
    gcloudComputeSsh: 'gcloud compute ssh',
    status: {
      running: '运行中',
      stopped: '已停止',
      terminated: '已终止',
      suspended: '已暂停',
      suspending: '暂停中',
      stopping: '停止中',
      shuttingDown: '关闭中',
      pending: '等待中',
      unknown: '未知'
    },
    onPremise: '本地'
  },

  // 磁盘相关
  disk: {
    name: '磁盘名称',
    size: '大小',
    status: '状态',
    zone: '区域',
    type: '类型',
    attached: '已附加',
    detached: '已分离',
    attachedDisk: '附加磁盘',
    detachDisk: '分离磁盘',
    deleteDisk: '删除磁盘',
    editLabels: '编辑标签',
    noDisks: '暂无磁盘',
    attachedVM: '挂载VM',
    details: '磁盘详情',
    ready: '就绪',
    creating: '创建中',
    restoring: '恢复中',
    unknown: '未知',
    systemDisk: '系统盘',
    status: {
      ready: '就绪',
      creating: '创建中',
      restoring: '恢复中',
      unknown: '未知',
      available: '可用',
      attached: '已挂载'
    },
    error: {
      missingZone: '无法附加磁盘：缺少区域（zone）信息。'
    },
    attachedTo: '挂载到',
    device: '设备',
    notAttached: '未挂载',
    na: '无'
  },

  // 标签相关
  labels: {
    title: '标签',
    owner: '所有者',
    team: '团队',
    org: '组织',
    editLabels: '编辑标签',
    saveLabels: '保存标签',
    labelsUpdated: '标签已更新',
    ownerPlaceholder: '输入所有者',
    teamPlaceholder: '输入团队',
    orgPlaceholder: '输入组织',
    noLabels: '无标签',
    manageLabels: '标签管理',
    currentLabels: '当前标签',
    invalidEmail: '请输入有效的邮箱地址'
  },

  // 团队
  team: {
    siDev: 'SI Dev',
    algoDev: 'Algo Dev',
    infraDev: 'Infra Dev',
    hi: 'HI'
  },

  // 组织
  org: {
    engineering: 'Engineering',
    product: 'Product'
  },

  // 创建VM模态框
  createVM: {
    title: '创建虚拟机',
    name: '名称',
    machineType: '机器类型',
    zone: '区域',
    bootDisk: '启动磁盘',
    bootDiskSize: '启动磁盘大小 (GB)',
    network: '网络',
    subnetwork: '子网',
    externalIP: '外部IP',
    allowHTTP: '允许HTTP流量',
    allowHTTPS: '允许HTTPS流量',
    create: '创建',
    cancel: '取消',
    nameRequired: '请输入名称',
    machineTypeRequired: '请选择机器类型',
    zoneRequired: '请选择区域',
    bootDiskSizeRequired: '请输入启动磁盘大小',
    creating: '创建中...',
    created: '虚拟机创建成功',
    error: '创建虚拟机失败',
    gpuType: 'GPU类型',
    gpuCount: 'GPU数量',
    image: '镜像',
    serviceAccount: '服务账号',
    estimatedMonthlyCost: '预计月度费用',
    createFailed: '创建VM失败',
    monthlyCostEstimate: '月度成本估算',
    computeResource: '计算资源',
    gpuResource: 'GPU ({0}, {1}个)',
    storageResource: '存储 ({size}GB)',
    total: '总计',
    month: '月',
    selectImage: '选择镜像',
    defaultServiceAccount: '默认（Compute Engine 默认服务账号）',
    a100AutoMatch: 'A100 GPU 40G 自动匹配 A2 高GPU型机器',
    gpuTypes: {
      none: '无GPU'
    },
    machineTypeGroups: {
      e2Series: 'E2 系列 (性价比型)',
      e2Standard: 'E2 标准型',
      e2HighCpu: 'E2 高CPU型',
      n1Standard: 'N1 标准型',
      g2StandardL4: 'G2 标准型 (L4 GPU)',
      n1StandardT4: 'N1 标准型 (T4 GPU)'
    },
    // AWS相关翻译
    region: '区域',
    instanceType: '实例类型',
    instanceTypeRequired: '请选择实例类型',
    volumeType: '卷类型'
  },

  // 创建磁盘模态框
  createDisk: {
    title: '创建磁盘',
    name: '名称',
    size: '大小 (GB)',
    type: '类型',
    zone: '区域',
    region: '区域',
    create: '创建',
    cancel: '取消',
    nameRequired: '请输入名称',
    sizeRequired: '请输入大小',
    typeRequired: '请选择类型',
    zoneRequired: '请选择区域',
    creating: '创建中...',
    created: '磁盘创建成功',
    error: '创建磁盘失败',
    estimatedMonthlyCost: '预计月度费用',
    createFailed: '创建磁盘失败',
    types: {
      standard: '标准持久化磁盘',
      ssd: 'SSD持久化磁盘',
      balanced: '平衡持久化磁盘'
    }
  },

  // 审计日志
  audit: {
    title: '审计日志',
    project: '项目',
    action: '操作',
    resource: '资源',
    user: '用户',
    timestamp: '时间',
    details: '详情',
    filter: '过滤',
    clear: '清除',
    noLogs: '暂无日志',
    selectProject: '选择项目',
    searchPlaceholder: '搜索操作者、资源名称...',
    allActions: '所有操作类型',
    allStatus: '所有状态',
    success: '成功',
    failed: '失败',
    pending: '进行中',
    allResourceTypes: '所有资源类型',
    allProjects: '所有项目',
    timeRange: '时间范围',
    export: '导出',
    last7Days: '最近7天',
    last30Days: '最近30天',
    last90Days: '最近90天',
    custom: '自定义',
    to: '至',
    totalRecords: '总记录数',
    successfulOperations: '成功操作',
    failedOperations: '失败操作',
    activeUsers: '活跃用户',
    time: '时间',
    operator: '操作者',
    actionType: '操作类型',
    resourceName: '资源名称',
    resourceType: '资源类型',
    projectId: '项目ID',
    status: '状态',
    duration: '耗时',
    noMatchingLogs: '没有找到匹配的审计日志',
    clearFilters: '清除筛选条件',
    pageInfo: '第 {current} 页，共 {total} 页 ({records} 条记录)',
    logDetails: '审计日志详情',
    basicInfo: '基本信息',
    operationTime: '操作时间',
    zone: '区域',
    ipAddress: 'IP地址',
    detailedInfo: '详细信息',
    errorInfo: '错误信息',
    fetchLogsFailed: '获取审计日志失败',
    fetchStatsFailed: '获取统计信息失败',
    actions: {
      vmCreate: '创建虚拟机',
      vmStart: '启动虚拟机',
      vmStop: '停止虚拟机',
      vmDelete: '删除虚拟机',
      diskCreate: '创建磁盘',
      diskDelete: '删除磁盘',
      diskAttach: '挂载磁盘',
      diskDetach: '分离磁盘'
    },
    statuses: {
      success: '成功',
      failed: '失败',
      pending: '进行中'
    }
  },

  // 通知
  notifications: {
    operationSuccess: '操作成功',
    operationFailed: '操作失败',
    confirmDelete: '确认删除？',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    attachSuccess: '附加成功',
    attachFailed: '附加失败',
    detachSuccess: '分离成功',
    detachFailed: '分离失败'
  },

  // 子区域相关
  subregion: {
    title: '子区域',
    unknown: '未知子区域'
  },

  // 语言切换
  language: {
    zh: '中文',
    en: 'English',
    ja: '日本語',
    switchLanguage: '切换语言'
  },

  // 站点切换
  siteSwitcher: {
    title: '站点切换器',
    currentSite: '当前站点',
    switchSite: '切换站点',
    awsSite: 'AWS管理器',
    gcpSite: 'GCP管理器',
    awsUrl: 'ec2-manager.robotruck.internal.jp',
    gcpUrl: 'gce-manager.robotruck.internal.jp',
    switching: '切换中...',
    switchConfirm: '确定要切换到 {site} 吗？',
    switchSuccess: '成功切换到 {site}',
    switchFailed: '切换站点失败'
  },

  // Composables 相关
  composables: {
    // 错误消息
    errors: {
      loadResourcesFailed: '加载资源失败',
      loadProjectsFailed: '获取项目列表失败',
      operationFailed: '操作失败',
      deleteFailed: '删除失败',
      attachFailed: '关联失败',
      detachFailed: '分离失败',
      createFailed: '创建失败',
      loadProjectFirst: '请先加载项目资源',
      fetchUserFailed: '获取用户数据失败'
    },
    // 确认消息
    confirm: {
      startVM: '确定要启动这台虚拟机吗？',
      stopVM: '确定要停止这台虚拟机吗？',
      deleteVM: '确定要删除这台虚拟机吗？此操作不可恢复！',
      resizeVM: '确定要调整这台虚拟机的规格吗？',
      deleteDisk: '确定要删除这个磁盘吗？此操作不可恢复！',
      detachDisk: '确定要从VM {vmName} 分离磁盘 {diskName} 吗？'
    },
    // 状态
    status: {
      running: '运行中',
      stopped: '已停止',
      terminated: '已终止',
      unknown: '未知',
      ready: '就绪',
      creating: '创建中',
      restoring: '恢复中'
    },
    // 日志消息
    logs: {
      connectedToServer: '已连接到服务器',
      disconnectedFromServer: '与服务器断开连接',
      websocketError: 'WebSocket错误',
      vmOperationFailed: 'VM操作失败',
      deleteDiskFailed: '删除磁盘失败',
      attachDiskFailed: '关联磁盘失败',
      detachDiskFailed: '分离磁盘失败',
      createDiskFailed: '创建磁盘失败',
      cannotGetVMMonitoring: '无法获取VM {vmName} 的监控数据',
      cannotGetDiskMonitoring: '无法获取磁盘 {diskName} 的监控数据',
      userNotAuthenticated: '用户未通过IAP认证',
      userAuthenticated: '用户已认证'
    },
    // 通知
    notifications: {
      autoRemove: '自动移除通知'
    }
  }
};
